import { BRAND } from "../../type/EnumBrand";
import { IBrand } from "../../type/IBrand";

export const ssl: IBrand = {
  id: "ssl",
  name: BRAND.SSL,
  logo: "/logo/ssl-logo.png",
  website: "https://www.solidstatelogic.com/",
  description: `
The legendary console brand.
`
}